import { createContext } from 'react'

import { JsonObject } from 'type-fest'

export type EnvSchema<E extends JsonObject = JsonObject> = E

const EnvContext = createContext<EnvSchema>({})

export default EnvContext
